import { useQuery } from "react-query";
import axios from "axios";
import { useState } from "react";
import "./examlanding.scss";
import Loader from "../components/loader";
import LoadError from "../components/error";
import { BrandButton, BrandButtonWhite } from "../components/form/buttons";
import AppHeader from "../components/appheader";
import { useLocation, useNavigate } from "react-router-dom";
import { ApiEndpoint } from "../components/utils";
import { pageIds } from "../components/utils";
import { Box, Modal } from "@mui/material";
import {
  getAppInfo,
  getCurrentSectionandQuestion,
  getUserInfo,
  updateCurrentExamData,
} from "../components/user";
import { AppInfoRecord, ConfigRecord } from "../components/types";
import { Alert, Snackbar } from "@mui/material";

interface PageResponse {
  headerTitle?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  welcomeMessage?: any;
}

const ExamLanding = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [data, setdata] = useState<PageResponse | null>();
  const { type } = location.state || {};
  const [configData, setConfigData] = useState<ConfigRecord | null>(null);
  const uData = getUserInfo();
  const [snackError, setSnackError] = useState(false);
  const [open, setOpen] = useState(true);

  const { isLoading, error } = useQuery("registerPageData", async () => {
    const resp = await axios.get(
      ApiEndpoint +
        "wp-json/satapp-api/v1/getPageText?slug=" +
        pageIds.exam_start
    );

    // get config data
    const resp2 = await axios.get(
      ApiEndpoint + `wp-json/satapp-api/v1/configData?token=${uData?.token}`
    );
    setConfigData(resp2.data);
    setdata(resp.data as PageResponse);
  });

  const beginExam = () => {
    const appInfo = getAppInfo() as AppInfoRecord;
    const examId = appInfo?.currentExamData?.examId as number;

    //set exam type and start time....
    const { currentSectionId } = getCurrentSectionandQuestion();
    const currentQuestionId =
      appInfo?.currentExamData?.examAnswers[0].questions[0].questionId;

    if (!appInfo?.currentExamData?.minutesRemaining) {
      let time =
        parseInt(type as string) === 0
          ? configData?.standardTime[currentSectionId as number]
          : configData?.extendedTime[currentSectionId as number];
      if (time) time = time / 1000 / 60;
      updateCurrentExamData(
        examId,
        {
          examType: parseInt(type as string),
          sectionStartTime: time,
          minutesRemaining: time ? time * 1000 * 60 : 0,
          examStarted: true,
          lastQuestionAnswered: currentQuestionId,
        },
        false
      );
    }

    if (currentSectionId || currentSectionId == 0) {
      navigate(`/question/${currentQuestionId}`, { replace: true });
    } else {
      setSnackError(true);
    }
  };

  const closeSnack = () => {
    setSnackError(false);
  };

  if (isLoading) return <Loader />;
  if (error) return <LoadError />;
  // if (!uData) return <LoadError />;

  return (
    <div className="examLandingPage">
      <AppHeader />
      <div className="headline">
        <h1>{data?.headerTitle}</h1>
        <div
          className="description"
          dangerouslySetInnerHTML={{ __html: data?.welcomeMessage }}
        />
      </div>
      <div className="btnHolder">
        <BrandButton onClick={beginExam}>BEGIN</BrandButton>
      </div>
      <Snackbar
        open={snackError}
        autoHideDuration={6000}
        onClose={closeSnack}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert severity="error">
          There was an error starting the exam. Please refresh or contact the
          administrator.
        </Alert>
      </Snackbar>
      <Modal
        open={open}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="modalHolderWarning">
          <div className="boxHolder">
            <div className="cta">
              <p>
                To ensure an optimal testing experience, before starting the
                test please close all other tabs and browsers, and consider
                shutting down any resource-intensive programs running on this
                device.
              </p>
              <BrandButtonWhite onClick={() => setOpen(false)}>
                CONFIRM &gt;
              </BrandButtonWhite>
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  );
};

export default ExamLanding;
